/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, createRef, useState, useMemo, useCallback, useRef } from "react";
import {
    Button,
    ButtonGroup,
    Card,
    CardBody,
    CardHeader,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import {
    currencyFormatWithAlert,
    currencyFormatWithoutDecimal,
    numberFormat,
} from "../../helpers/api_helper";
import Loader from "../../Components/Common/Loader";
import { getDateByName, convertDateFormate } from "../../helpers/api_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_KPI_DASHBOARD } from "../../helpers/data_helper";
import CustomPagination from "../../Components/Common/CustomPagination";
import CheckListingPopup from "./CheckListingPopup";
import moment from "moment";

const itemsPerPage = 50;
let sorttypefinalvalue;
const CheckListingItems = ({
    mealPeriod,
    activeDate,
    customDate,
    currency,
    serveList
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggle = () => setIsModalOpen(!isModalOpen)
    const [selectedPage, setSelectedPage] = useState(0);
    const [discountCheckLists, setDiscountCheckLists] = useState([]);
    const [discountCheckListsAjax, setDiscountCheckListsAjax] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [selectedCheck, setSelectedCheck] = useState(null);
    const [checkDetails, setCheckDetails] = useState(null);
    const [loadingCheckDetails, setLoadingCheckDetails] = useState(false);
    const [searchCheckNumber, setSearchCheckNumber] = useState("");
    const debounceTimerRef = useRef(null);

    const debouncedSearch = useCallback((value) => {
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(() => {
            setSearchCheckNumber(value);
            setSelectedPage(0);
        }, 500); // 500ms debounce delay
    }, []);
    const [exporting, setExporting] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        setDiscountCheckListsAjax(true);
        const requestPayload = {
            dateFilter: activeDate.value === 'Custom' ? { from: convertDateFormate(customDate[0]), to: convertDateFormate(customDate[1]) } : getDateByName(activeDate.value),
            serviceName: 'kpi_data',
            op: 'check_listing',
            mealPeriod: mealPeriod,
            server_id: serveList,
            page: selectedPage,
        };
        
        // Add check_number to payload if search is active
        if (searchCheckNumber.trim() !== "") {
            requestPayload.check_number = searchCheckNumber.trim();
        }
        
         postDataAPI(requestPayload, controller.signal).then((response) => {
            setDiscountCheckListsAjax(false);
            if (response.status === "ok") {
                setPageCount(response?.data?.totalData)
                setDiscountCheckLists(response?.data?.data || []);
            } else {
                console.log("Error when getting check listing");
            }
            
        });
        return () => {
            controller.abort();
        };
    }, [selectedPage, activeDate, customDate, mealPeriod, serveList, searchCheckNumber.trim()]);

    // Cleanup debounce timer on unmount
    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);
    
    const [sortColumn, SetSortColumn] = useState("");

    const columnDef = [
        {
            name: "Date",
            key: "date",
            className: "text-start",
        },
        {
            name: "Check",
            key: "check",

        },
        {
            name: 'Employee',
            key: 'employee',
        },
        {
            name: "Open",
            key: "open",
        },
        {
            name: "Close",
            key: "close",
        },
        {
            name: "Turn Time",
            key: "turn_time",
        },
        {
            name: "Table No",
            key: "table_no",
        },
        {
            name: "Covers",
            key: "covers",
        },
        {
            name: "Avg. Check",
            key: "avg_check",
        },
        {
            name: "Revenue",
            key: "revenue",
        },
        {
            name: 'Discounted',
            key: 'discounted'
        },
        {
            name: 'Meal Period',
            key: 'meal_period'
        },
        {
            name: 'Food %',
            key: 'food_percentage'
        },
        {
            name: 'Payment'
            , key: 'payment'
        }

    ];
    const [showColumns, setShowColumns] = useState(
        columnDef.map((column) => column.key)
    );

    const [isOpen, setIsOpen] = useState(false);
    const columnDropdownRef = createRef();
    const toggleDropdown = (e) => {
        if (columnDropdownRef.current.contains(e.target)) return;

        setIsOpen(!isOpen);
    };
    const handleColumnHideShow = (event, columnName) => {
        event.stopPropagation();
        if (showColumns.includes(columnName)) {
            setShowColumns(showColumns.filter((column) => column !== columnName));
        } else {
            setShowColumns([...showColumns, columnName]);
        }
        console.log(event.target.value);
    };
    
    const filteredColumns = useMemo(
        () => columnDef.filter((column) => showColumns.includes(column.key)),
        [showColumns, columnDef]
    );

    const handleCheckClick = async (checkNumber, item) => {
        console.log("checkNumber",checkNumber);
        
        setSelectedCheck(checkNumber);
        setLoadingCheckDetails(true);
        setIsModalOpen(true);

        try {
            const response = await postDataAPI({
                serviceName: "kpi_data",
                op: "check_details",
                check_number: checkNumber,
            });

            if (response.status === "ok") {
                setCheckDetails({
                    ...response?.data?.data,  // all API response fields
                    itemData: item,    // attach the full item object under a new key
                });
            } else {
                console.error("Failed to fetch check details");
                setIsModalOpen(false);
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setLoadingCheckDetails(false);
        }
    };

    const handleExport = async () => {
        try {
          setExporting(true);

          const exportPayload = {
            dateFilter:
              activeDate.value === "Custom"
                ? {
                    from: convertDateFormate(customDate[0]),
                    to: convertDateFormate(customDate[1]),
                  }
                : getDateByName(activeDate.value),
            serviceName: "kpi_data",
            op: "check_listing",
            mealPeriod: mealPeriod,
            server_id: serveList,
            page: selectedPage,
            export: 1,
            exportColumns: showColumns,
          };

          const response = await postDataAPI(exportPayload);
          if (response.status === "ok") {
            const filename = response?.data?.file_name;
            if (filename) {
                const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + response.data?.excel_file;
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = filename;
                downloadLink.click();
            } else {
              console.error("Export response did not contain a filename.");
            }
          } else {
            console.error("Export failed:", response);
          }
        } catch (error) {
          console.error("Export API error:", error);
        } finally {
          setExporting(false);
        }
    };


    return (
        <React.Fragment>
            <Card>
                <CardHeader className="align-items-center d-flex ps-0 pe-0">
                    <div className="d-flex align-items-center flex-grow-1">
                        <div className={`icon-box rounded bg-danger text-white`}>
                            <i className="ri-bar-chart-fill"></i>
                        </div>
                        <div className="ps-2">
                            <h4 className="card-title mb-1">
                                Check Listings
                            </h4>
                            <p className="text-muted mb-0">
                                Check Listings
                            </p>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="d-flex align-items-center ct_top_margin gap-2">
                            <Input
                                type="search"
                                placeholder="Search by Check Number"
                                defaultValue={searchCheckNumber}
                                onChange={(e) => debouncedSearch(e.target.value)}
                                style={{ width: "210px" }}
                            />
                            <Dropdown
                                isOpen={isOpen}
                                toggle={toggleDropdown}
                                className="ms-3 ct_left_margin_zero"
                                style={{ borderRadius: "0.25rem" }}
                            >
                                <ButtonGroup>
                                    <Button color="info">Columns</Button>
                                    <DropdownToggle
                                        tag="button"
                                        className="btn btn-info"
                                        split
                                    ></DropdownToggle>
                                </ButtonGroup>
                                <DropdownMenu className="dropdown-menu-end" end={true}>
                                    <div ref={columnDropdownRef}>
                                        {columnDef.map((column) => (
                                            <DropdownItem
                                                onClick={(event) => {
                                                    handleColumnHideShow(event, column.key);
                                                }}
                                                key={column.key}
                                            >
                                                <div className="form-check mb-1">
                                                    <Input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`column${column.key}`}
                                                        checked={showColumns.includes(column.key)}
                                                        value={column.key}
                                                        readOnly
                                                    />
                                                    <Label className="form-check-label" for="formCheck6">
                                                        {column.name}
                                                    </Label>
                                                </div>
                                            </DropdownItem>
                                        ))}
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                            {/* <ExportExcel fileName="ServerPerformance" excelData={discountCheckLists} /> */}
                            <Button className="ms-3" color="primary" onClick={handleExport} disabled={exporting}>
                                {exporting ? "Exporting..." : "Export"}
                            </Button>
                        </div>
                    </div>
                </CardHeader>

                <CardBody>
                    {discountCheckListsAjax && <Loader />}
                    <div
                        id="CheckListings"
                        className={
                            discountCheckListsAjax
                                ? "opacity-0 table-responsive table-card"
                                : "table-responsive table-card"
                        }
                        style={{ maxHeight: "500px", overflow: "auto" }}
                    >
                        <table className="table table-borderless table-centered align-middle table-nowrap mb-0 text-center">
                            <thead className="text-muted table-light">
                                <tr style={{ position: "sticky", top: "-2px" }}>
                                    {filteredColumns.map(
                                        (column) =>
                                            showColumns.includes(column.key) && (
                                                <th
                                                    className={column.className}
                                                    key={column.key}
                                                    scope="col"
                                                >
                                                    {column.name}{" "}
                                                    {/* {column.sort && (
                                                        <i
                                                            className="las la-arrow-down"
                                                            style={{
                                                                cursor: "pointer",
                                                                transform:
                                                                    sortColumn === column.key &&
                                                                        sorttypefinalvalue === "DESC"
                                                                        ? "rotate(180deg)"
                                                                        : "rotate(0deg)",
                                                            }}
                                                            onClick={() => handleSort(column.key, "sortcall")}
                                                        ></i>
                                                    )} */}
                                                </th>
                                            )
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {(discountCheckLists || []).map((item, key) => (
                                    <tr key={key}>
                                        {showColumns.includes("date") && (
                                            <td className="text-start">{moment(item.date).format("DD MMM YYYY")}</td>
                                        )}
                                        {showColumns.includes("check") && (
                                            <td
                                                className="cursor-pointer text-center text-primary"
                                                onClick={() => handleCheckClick(item.check, item)}
                                            >
                                                {numberFormat(item.check)}
                                            </td>
                                        )}
                                        {showColumns.includes("employee") && (
                                            <td>{item.employee}</td>
                                        )}
                                        {showColumns.includes("open") && (
                                            <td>{numberFormat(item.open)}</td>
                                        )}
                                        {showColumns.includes("close") && (
                                            <td>{numberFormat(item.close)}</td>
                                        )}
                                        {showColumns.includes("turn_time") && (
                                            <td>{numberFormat(item.turn_time)}</td>
                                        )}
                                        {showColumns.includes("table_no") && (
                                            <td>{item.table_no}</td>
                                        )}
                                        {showColumns.includes("covers") && (
                                            <td>{numberFormat(item.covers)}</td>
                                        )}
                                        {showColumns.includes("avg_check") && (
                                            <td>
                                                {currencyFormatWithAlert(item.avg_check, currency)}
                                            </td>
                                        )}
                                        {showColumns.includes("revenue") && (
                                            <td>
                                                {currencyFormatWithoutDecimal(item.revenue, currency)}
                                            </td>
                                        )}
                                        {showColumns.includes("discounted") && (
                                            <td>{item.discounted}</td>
                                        )}
                                        {showColumns.includes("meal_period") && (
                                            <td>{item.meal_period}</td>
                                        )}
                                        {showColumns.includes("food_percentage") && (
                                            <td>{numberFormat(item.food_percentage)}</td>
                                        )}
                                        {showColumns.includes("payment") && (
                                            <td>{currencyFormatWithAlert(item.payment,currency)}</td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-4 float-end">
                        <nav>
                            <CustomPagination
                                pageCount={pageCount}
                                setSelectedPage={setSelectedPage}
                            />
                        </nav>
                    </div>
                </CardBody>
            </Card>

            <Modal isOpen={isModalOpen} toggle={toggle} centered size="lg">
                <ModalHeader toggle={toggle} style={{ backgroundColor: '#F8F9FC' }}>
                    Check #{selectedCheck}
                </ModalHeader>
                <ModalBody style={{ backgroundColor: '#F8F9FC' }}>
                    <div style={{ overflow: 'auto', maxHeight: '600px' }}>
                    {loadingCheckDetails ? (
                        <Loader />
                    ) : (
                        <CheckListingPopup data={checkDetails} currency={currency} />
                    )}
                    </div>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};

export default CheckListingItems;
